<template>
  <div class="operations-page">
    <section class="about-hero">
      <div class="about-info-title">
        <div>
          <h1 style="color: white !important">
            <span v-html="filterData('GALLERY_01_' + language)"></span>
          </h1>
        </div>
      </div>
    </section>

    <section class="gallery-section">
      <div class="about-info">
        <!-- Sección Lixiviación -->
        <div class="gallery-container" v-if="unifiedContentHidro.length > 0">
          <div>
            <h2 class="gallery-title">
              <span v-html="filterData('GALLERY_02_' + language)"></span>
            </h2>
          </div>

          <div class="gallery-grid">
            <div
              v-for="(item, index) in unifiedContentHidro"
              :key="index"
              class="gallery-item"
              @click="item.type === 'image' ? openLightbox(item.id) : null"
            >
              <v-img
                v-if="item.type === 'image'"
                :src="searchImage(item.id)"
                class="gallery-image"
                aspect-ratio="1"
                cover
              ></v-img>
              <iframe
                v-else
                :src="getEmbedUrl(item.path)"
                frameborder="0"
                allowfullscreen
                class="gallery-image"
                style="height: 250px"
              ></iframe>
            </div>
          </div>
        </div>

        <!-- Sección Mina -->
        <div class="gallery-container" v-if="unifiedContentMina.length > 0">
          <div>
            <h2 class="gallery-title">
              <span v-html="filterData('GALLERY_03_' + language)"></span>
            </h2>
          </div>

          <div class="gallery-grid">
            <div
              v-for="(item, index) in unifiedContentMina"
              :key="index"
              class="gallery-item"
              @click="item.type === 'image' ? openLightbox(item.id) : null"
            >
              <v-img
                v-if="item.type === 'image'"
                :src="searchImage(item.id)"
                class="gallery-image"
                aspect-ratio="1"
                cover
              ></v-img>
              <iframe
                v-else
                :src="getEmbedUrl(item.path)"
                frameborder="0"
                allowfullscreen
                class="gallery-image"
                style="height: 250px"
              ></iframe>
            </div>
          </div>
        </div>

        <!-- Sección Trituración -->
        <div
          class="gallery-container"
          v-if="unifiedContentTrituracion.length > 0"
        >
          <div>
            <h2 class="gallery-title">
              <span v-html="filterData('GALLERY_04_' + language)"></span>
            </h2>
          </div>

          <div class="gallery-grid">
            <div
              v-for="(item, index) in unifiedContentTrituracion"
              :key="index"
              class="gallery-item"
              @click="item.type === 'image' ? openLightbox(item.id) : null"
            >
              <v-img
                v-if="item.type === 'image'"
                :src="searchImage(item.id)"
                class="gallery-image"
                aspect-ratio="1"
                cover
              />
              <iframe
                v-else
                :src="getEmbedUrl(item.path)"
                frameborder="0"
                allowfullscreen
                class="gallery-image"
                style="height: 250px"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Lightbox Modal -->
    <div v-if="showLightbox" class="lightbox" @click="closeLightbox">
      <div class="lightbox-content">
        <img :src="searchImage(currentImage)" alt="Gallery image" />
        <button class="close-btn" @click.stop="closeLightbox">×</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { getLanguage, BASEURL } from "@/kernel/utils";
import {
  getSectionByPageandlanguage,
  getImageBySection,
} from "@/modules/sections/services/sections-service";

const language = ref(getLanguage());
const imagesHidro = ref([
  "GALLERY_A_01",
  "GALLERY_A_02",
  "GALLERY_A_03",
  "GALLERY_A_04",
  "GALLERY_A_05",
  "GALLERY_A_06",
  "GALLERY_A_07",
  "GALLERY_A_08",
  "GALLERY_A_09",
  "GALLERY_A_10",
  "GALLERY_A_11",
  "GALLERY_A_12",
  "GALLERY_A_13",
  "GALLERY_A_14",
  "GALLERY_A_15",
  "GALLERY_A_16",
  "GALLERY_A_17",
  "GALLERY_A_18",
  "GALLERY_A_19",
  "GALLERY_A_20",
  "GALLERY_A_21",
  "GALLERY_A_22",
  "GALLERY_A_23",
  "GALLERY_A_24",
  "GALLERY_A_25",
  "GALLERY_A_26",
  "GALLERY_A_27",
  "GALLERY_A_28",
  "GALLERY_A_29",
  "GALLERY_A_30",
]);

const imagesMina = ref([
  "GALLERY_B_01",
  "GALLERY_B_02",
  "GALLERY_B_03",
  "GALLERY_B_04",
  "GALLERY_B_05",
  "GALLERY_B_06",
  "GALLERY_B_07",
  "GALLERY_B_08",
  "GALLERY_B_09",
  "GALLERY_B_10",
  "GALLERY_B_11",
  "GALLERY_B_12",
  "GALLERY_B_13",
  "GALLERY_B_14",
  "GALLERY_B_15",
  "GALLERY_B_16",
  "GALLERY_B_17",
  "GALLERY_B_18",
  "GALLERY_B_19",
  "GALLERY_B_20",
  "GALLERY_B_21",
  "GALLERY_B_22",
  "GALLERY_B_23",
  "GALLERY_B_24",
  "GALLERY_B_25",
  "GALLERY_B_26",
  "GALLERY_B_27",
  "GALLERY_B_28",
  "GALLERY_B_29",
  "GALLERY_B_30",
]);

const imagesTrituracion = ref([
  "GALLERY_C_01",
  "GALLERY_C_02",
  "GALLERY_C_03",
  "GALLERY_C_04",
  "GALLERY_C_05",
  "GALLERY_C_06",
  "GALLERY_C_07",
  "GALLERY_C_08",
  "GALLERY_C_09",
  "GALLERY_C_10",
  "GALLERY_C_11",
  "GALLERY_C_12",
  "GALLERY_C_13",
  "GALLERY_C_14",
  "GALLERY_C_15",
  "GALLERY_C_16",
  "GALLERY_C_17",
  "GALLERY_C_18",
  "GALLERY_C_19",
  "GALLERY_C_20",
  "GALLERY_C_21",
  "GALLERY_C_22",
  "GALLERY_C_23",
  "GALLERY_C_24",
  "GALLERY_C_25",
  "GALLERY_C_26",
  "GALLERY_C_27",
  "GALLERY_C_28",
  "GALLERY_C_29",
  "GALLERY_C_30",
]);

// Lightbox functionality
const showLightbox = ref(false);
const currentImage = ref("");

const openLightbox = (image) => {
  currentImage.value = image;
  showLightbox.value = true;
  document.body.style.overflow = "hidden";
};

const closeLightbox = () => {
  showLightbox.value = false;
  document.body.style.overflow = "auto";
};

const dataGallery = ref([
  {
    section_id: "GALLERY_01_EN",
    description: "Gallery",
  },
  {
    section_id: "GALLERY_01_ES",
    description: "Galería",
  },
  {
    section_id: "GALLERY_02_EN",
    description: "Leaching and SX/EW",
  },
  {
    section_id: "GALLERY_02_ES",
    description: "Lixiviación y SX/EW",
  },
  {
    section_id: "GALLERY_03_EN",
    description: "Mine",
  },
  {
    section_id: "GALLERY_03_ES",
    description: "Mina",
  },
  {
    section_id: "GALLERY_04_EN",
    description: "Crushing System",
  },
  {
    section_id: "GALLERY_04_ES",
    description: "Sistema de trituración",
  },
]);

const fetchData = async () => {
  try {
    const dataForm = {
      page: "GALLERY",
      language: language.value,
    };
    const response = await getSectionByPageandlanguage(dataForm);
    if (response.status === 200) {
      if (parseInt(response.data.length) !== 0) {
        dataGallery.value = response.data;
      }
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

const filterData = (found_id) => {
  const filteredData = dataGallery.value.filter(
    (item) => item.section_id === found_id
  );
  return filteredData.length > 0 ? filteredData[0].description : null;
};

const defaultImages = [
  { id: "GALLERY_A_01", path: "hidrometalurgia-01.jpg" },
  { id: "GALLERY_A_02", path: "hidrometalurgia-02.jpg" },
  { id: "GALLERY_A_03", path: "hidrometalurgia-03.jpg" },
  { id: "GALLERY_A_04", path: "hidrometalurgia-04.jpg" },
  { id: "GALLERY_A_05", path: "hidrometalurgia-05.jpg" },
  { id: "GALLERY_A_06", path: "hidrometalurgia-06.jpg" },
  { id: "GALLERY_B_01", path: "mina-01.jpg" },
  { id: "GALLERY_B_02", path: "mina-03.jpg" },
  { id: "GALLERY_B_03", path: "mina-04.jpg" },
  { id: "GALLERY_B_04", path: "mina-05.jpg" },
  { id: "GALLERY_B_05", path: "mina-06.jpg" },
  { id: "GALLERY_C_01", path: "trituracion-01.jpg" },
  { id: "GALLERY_C_02", path: "trituracion-02.jpg" },
  { id: "GALLERY_C_03", path: "trituracion-03.jpg" },
  { id: "GALLERY_C_04", path: "trituracion-04.jpg" },
];

// Variable de galería cargada dinámicamente
const imagesGallery = ref([]);

// Función para verificar si una imagen existe
const imageExists = (imageId) => {
  const foundDynamic = imagesGallery.value.find(
    (img) => img.image_id === imageId
  );
  if (foundDynamic) return true;

  const foundDefault = defaultImages.find((img) => img.id === imageId);
  if (foundDefault) return true;

  return false;
};

// Esta función ahora intenta buscar una imagen dinámica y si no existe, retorna la ruta default
const searchImage = (imageId) => {
  const foundDynamic = imagesGallery.value.find(
    (img) => img.image_id === imageId
  );
  if (foundDynamic) return `${BASEURL}${foundDynamic.image_path}`;

  const foundDefault = defaultImages.find((img) => img.id === imageId);
  if (foundDefault) return `${BASEURL}/img/gallery/${foundDefault.path}`;

  return `${BASEURL}/img/gallery/placeholder.jpg`;
};

// Computed properties para contenido unificado (imágenes + videos)
const unifiedContentHidro = computed(() => {
  const images = imagesHidro.value
    .filter((imageId) => imageExists(imageId))
    .map((imageId) => ({ type: "image", id: imageId }));

  const videos = imagesGallery.value
    .filter((img) => img.image_id && img.image_id.startsWith("V_GALLERY_A_"))
    .map((video) => ({
      type: "video",
      id: video.image_id,
      path: video.image_path,
    }));

  return [...images, ...videos];
});

const unifiedContentMina = computed(() => {
  const images = imagesMina.value
    .filter((imageId) => imageExists(imageId))
    .map((imageId) => ({ type: "image", id: imageId }));

  const videos = imagesGallery.value
    .filter((img) => img.image_id && img.image_id.startsWith("V_GALLERY_B_"))
    .map((video) => ({
      type: "video",
      id: video.image_id,
      path: video.image_path,
    }));

  return [...images, ...videos];
});

const unifiedContentTrituracion = computed(() => {
  const images = imagesTrituracion.value
    .filter((imageId) => imageExists(imageId))
    .map((imageId) => ({ type: "image", id: imageId }));

  const videos = imagesGallery.value
    .filter((img) => img.image_id && img.image_id.startsWith("V_GALLERY_C_"))
    .map((video) => ({
      type: "video",
      id: video.image_id,
      path: video.image_path,
    }));

  return [...images, ...videos];
});

const getImages = async () => {
  try {
    const dataForm = {
      page: "GALLERY",
    };
    const result = await getImageBySection(dataForm);
    if (result.status === 200) {
      if (result.data.content !== null) {
        imagesGallery.value = result.data.content;
      }
    }
  } catch (error) {
    console.log("Error fetching images:", error);
  }
};


const getEmbedUrl = (url) => {
  if (!url) return "";

  // YouTube
  if (url.includes("youtube.com") || url.includes("youtu.be")) {
    const id = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/)?.[1];
    return id ? `https://www.youtube.com/embed/${id}` : "";
  }

  // Vimeo
  if (url.includes("vimeo.com")) {
    const id = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1];
    return id ? `https://player.vimeo.com/video/${id}` : "";
  }

  //Tiktok
  if (url.includes("tiktok.com")) {
    const id = url.match(/tiktok\.com\/(?:video\/)?(\d+)/)?.[1];
    return id ? `https://www.tiktok.com/embed/${id}` : "";
  }

  // Twitch
  if (url.includes("twitch.tv")) {
    const id = url.match(/twitch\.tv\/(?:video\/)?(\d+)/)?.[1];
    return id ? `https://player.twitch.tv/?video=${id}` : "";
  }

  // Dailymotion
  if (url.includes("dailymotion.com")) {
    const id = url.match(/dailymotion\.com\/(?:video\/)?(\d+)/)?.[1];
    return id ? `https://www.dailymotion.com/embed/video/${id}` : "";
  }

  // Facebook
  if (url.includes("facebook.com")) {
    const id = url.match(/facebook\.com\/(?:video\/)?(\d+)/)?.[1];
    return id ? `https://www.facebook.com/embed/${id}` : "";
  }

  // Instagram
  if (url.includes("instagram.com")) {
    const id = url.match(/instagram\.com\/(?:video\/)?(\d+)/)?.[1];
    return id ? `https://www.instagram.com/embed/${id}` : "";
  }

  return url; // fallback
};


onMounted(() => {
  fetchData();
  getImages();
});
</script>

<style scoped>
.operations-page {
  font-family: "Now Regular";
  color: #333;
  line-height: 1.6;
}

/* Hero Section */
.about-hero {
  height: 60vh;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("https://api3.cobredelmayo.com/api/public/img/bg-about.jpg")
      center/cover no-repeat;
  display: flex !important;
  align-items: end !important;
  justify-content: start !important;
  text-align: end !important;
  color: white !important;
  position: relative;
}

.hero-overlay {
  z-index: 1;
}

.about-hero h1 {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  border: 0px solid transparent;
}

/* Gallery Section */
.gallery-section {
  background-color: #f8f9fa;
}

.gallery-container {
  margin-top: 32px;
}

.gallery-container:last-child {
  padding-bottom: 0;
}

.gallery-title {
  text-align: start;
  margin-bottom: 40px;
  color: #2c3e50;
  font-size: 2rem;
  position: relative;
  padding-bottom: 15px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.gallery-item {
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.gallery-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-item:hover .gallery-image {
  transform: scale(1.05);
}

/* Video specific styles */
video.gallery-image {
  height: 250px;
  object-fit: cover;
}

/* Lightbox Styles */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.lightbox-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.lightbox-content img {
  max-width: 100%;
  max-height: 80vh;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 2.5rem;
  cursor: pointer;
  padding: 0 10px;
}

.close-btn:hover {
  color: orange;
}

@media (max-width: 768px) {
  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  .gallery-title {
    font-size: 1.5rem;
  }

  .about-hero h1 {
    font-size: 2.5rem;
  }

  .gallery-container {
    padding-bottom: 40px;
  }
}
</style>
